import { gql } from 'apollo-angular';

export const GET_PAYMENT_AGREEMENTS = gql`
  query ($criteria: SearchInPaymentAgreementListCriteria!) {
    searchInPaymentAgreementList(criteria: $criteria) {
      totalResults
      results {
        id
        collector {
          id
          name
        }
        status
        customer {
          id
          externalId
          longName
        }
        operations {
          id
          externalId
          title
          status
          dueDate
          amount {
            amount
            currency
          }
        }
        startDate
        nextPaymentDate
        instalments {
          paid
          total
        }
        amount {
          amount
          currency
        }
        paidAmount {
          amount
          currency
        }
      }
    }
  }
`;

export const EXPORT_PAYMENT_AGREEMENTS_LIST = gql`
  query ($fileId: ID!, $criteria: ExportPaymentAgreementListCriteria!) {
    exportPaymentAgreementList(fileId: $fileId, criteria: $criteria) {
      url
    }
  }
`;

export const VALIDATE_DEPENDENCIES = gql`
  query ($customerCaseId: ID!) {
    validatePaymentAgreementsDependencies(customerCaseId: $customerCaseId)
  }
`;

export const CALCULATE_INSTALMENTS = gql`
  query ($customerCaseId: ID!, $numberOfInstalments: Int!) {
    calculatePaymentAgreementInstalments(
      customerCaseId: $customerCaseId
      numberOfInstalments: $numberOfInstalments
    ) {
      amount {
        amount
        currency
      }
    }
  }
`;

export const BREAK_PAYMENT_AGREEMENT = gql`
  mutation ($id: ID!, $input: BreakPaymentAgreementInput!) {
    breakPaymentAgreement(id: $id, input: $input) {
      id
      tenantId
      customerCaseId
      status
      amount {
        amount
        currency
      }
      paymentGatewayId
      signatureDate
      nextPaymentDate
      fulfilmentDate
      breakDate
      breakReason
      instalments {
        amount {
          amount
          currency
        }
        attempts
        status
      }
    }
  }
`;

export const CREATE_PAYMENT_AGREEMENT_LIST_JOB = gql`
  mutation ($input: CreatePaymentAgreementListJobInput!) {
    createPaymentAgreementListJob(input: $input) {
      id
      tenantId
      type
      parameters
      paymentAgreementIds
      filters {
        tenantId
        collectorIds
        status
        operationExternalIds
        customerExternalIds
      }
    }
  }
`;

export const GET_PAYMENT_AGREEMENT_BY_ID = gql`
  query ($id: ID!) {
    paymentAgreement(id: $id) {
      id
      tenantId
      customerCaseId
      status
      amount {
        amount
        currency
      }
      paymentGatewayId
      signatureDate
      nextPaymentDate
      fulfilmentDate
      breakDate
      breakReason
      instalments {
        id
        amount {
          amount
          currency
        }
        attempts
        status
        schedulePaymentDate
        settlementDate
      }
      createdAt
    }
  }
`;
